import {useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {useGetProductByAll2Mutation} from "../../../../store/user/userProductApiSlice";

export default function GolfItems() {

  const navigate = useNavigate();
  const icons1 = `<div class="iconBox">
      <ul style="padding-bottom: 15px; display: flex; list-style: none;">
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_icon_Dual-LCD.png" alt="Dual LCD" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Dual LCD</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_icon_Aiming-Mode.png" alt="Aiming Mode" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Aiming Mode</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_icon_Smart-Club-Recommendation.png" alt="Smart Club Recommendation" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Smart Club<br/> Recommendation</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_icon_Distance-Triangulation-Mode.png" alt="Distance Triangulation Mode" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Distance Triangulation Mode</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_icon_0.1-sec-Measurement.png" alt="0.1sec Measurement" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">0.1sec<br/> Measurement</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_icon_Compact-&-Lightweight.png" alt="Compact & Lightweight" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Compact & Lightweight</span>
          </li>
      </ul>
      <ul style="padding-bottom: 15px; display: flex; list-style: none;">
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_icon_Continuous-Scan-Mode.png" alt="Continuous Scan Mode" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Continuous<br/> Scan Mode</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_icon_Slope-Mode.png" alt="Slope Mode" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Slope Mode</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_icon_Tournament-Mode.png" alt="Tournament Mode" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Tournament Mode</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_icon_Pin-Finder-with-Haptic-Feedback.png" alt="Pin Finder with Haptic Feedback" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Pin Finder with<br/> Haptic Feedback</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_icon_6X-Magnification.png" alt="6X Magnification" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">6X Magnification</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_icon_Long-Range-Measurement.png" alt="Long Range Measurement" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Long Range<br/> Measurement</span>
          </li>
      </ul>
      
      <ul style="padding-bottom: 15px; display: flex; list-style: none;">
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_icon_Yard_Meter-Switch.png" alt="Yard/Meter Switch" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Yard/Meter<br/> Switch</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_icon_Intuitive-UX.png" alt="Intuitive UX" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Intuitive UX</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_icon_Rainproof-Design.png" alt="Rainproof Design" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Rainproof Design</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_icon_Up-to-1,800-Measurements.png" alt="Up to 1,800 Measurements" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Up to 1,800<br/> Measurements</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_icon_Rechargeable-via-USB‑C.png" alt="Rechargeable via USB‑C" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Rechargeable via<br/> USB‑C</span>
          </li>
      </ul>
  </div>`;

  const icons2 = `<div class="iconBox">
      <ul style="padding-bottom: 15px; display: flex; list-style: none;">
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl9/icon/UPL9_icon_0.1 sec Measurement.png" alt="0.1 sec Measurement" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">0.1 sec<br/> Measurement</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl9/icon/UPL9_icon_Ultra‑Lightweight, Card-Sized.png" alt="Ultra‑Lightweight, Card-Sized" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Ultra‑Lightweight,<br/> Card-Sized</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl9/icon/UPL9_icon_Distance-Triangulation-Mode.png" alt="Distance Triangulation Mode" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Distance<br/> Triangulation Mode</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl9/icon/UPL9_icon_Continuous-Scan-Mode.png" alt="Continuous Scan Mode" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Continuous Scan<br/> Mode</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl9/icon/UPL9_icon_Slope-Mode.png" alt="Slope Mode" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Slope Mode</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl9/icon/UPL9_icon_Tournament-Mode.png" alt="Tournament Mode" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Tournament Mode</span>
          </li>
      </ul>
      <ul style="padding-bottom: 15px; display: flex; list-style: none;">
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl9/icon/UPL9_icon_Pin-Finder-with-Haptic-Feedback.png" alt="Pin Finder with Haptic Feedback" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Pin Finder<br/> with Haptic<br/> Feedback</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl9/icon/UPL9_icon_6X-Magnification.png" alt="6X Magnification" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">6X Magnification</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl9/icon/UPL9_icon_Long-Range-Measurement.png" alt="Long Range Measurement" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Long Range<br/> Measurement</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl9/icon/UPL9_icon_Yard_Meter-Switch.png" alt="Yard/Meter Switch" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Yard/Meter Switch</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl9/icon/UPL9_icon_Intuitive-UX.png" alt="Intuitive UX" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Intuitive UX</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl9/icon/UPL9_icon_Rainproof-Design.png" alt="Rainproof Design" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Rainproof Design</span>
          </li>
      </ul>
      <ul style="padding-bottom: 15px; display: flex; list-style: none;">
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl9/icon/UPL9_icon_Up-to-5,000-Measurements.png" alt="Up to 5,000 Measurements" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Up to 5,000<br/> Measurements</span>
          </li>
          <li style="width: 16.66%;">
              <div style="margin-bottom: 15px; height: 45px; position: relative;">
                  <img src="/assets/images/new/upl9/icon/UPL9_icon_Rechargeable-via-USB‑C.png" alt="Rechargeable via USB‑C" style="object-fit: contain; display: block; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
              </div>
              <span style="display: block; font-size: 14px; line-height: 17px; font-weight: 400; color: #555555; text-align: center;">Rechargeable via<br/> USB‑C</span>
          </li>
      </ul>
  </div>`;

  return (
    <>
      <div className="contentBox">
        <div className="titleBox">
          <h2>PRODUCT INFORMATION</h2>
        </div>
        <ul>
          <li>
            <div>
              <div
                className="left"
                onClick={() => navigate(`/products/100?product=UPL2000`)}
              >
                <div className="imgBox">
                  <img src="/assets/images/new/upl2000/icon/UPL2000_500x500_01.jpg" alt="UPL2000"/>
                </div>
              </div>
              <div className="right">
                <h3
                  onClick={() => navigate(`/products/100?product=UPL2000`)}
                >
                  UPL2000
                </h3>
                <div dangerouslySetInnerHTML={{__html: icons1}}></div>
              </div>
            </div>
          </li>
          <li>
            <div>
              <div
                className="left"
                onClick={() => navigate(`/products/101?product=UPL9`)}
              >
                <div className="imgBox">
                  <img src="/assets/images/new/upl9/icon/UPL9_500x500_01.jpg" alt="UPL9"/>
                </div>
              </div>
              <div className="right">
                <h3
                  onClick={() => navigate(`/products/101?product=UPL9`)}
                >
                  UPL9
                </h3>
                <div dangerouslySetInnerHTML={{__html: icons2}}></div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}
